// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import RegistrationPaymentListComponent from '../../components/finance/registration/registration';
import OrdersListComponent from '../../components/finance/orders/orders';
import QuotePaymentListComponent from '../../components/finance/quotes/quotes';

// Primereact imports
import { TabMenu } from 'primereact/tabmenu';

// Styling
import './payments.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';
import { isMobileOnly } from 'react-device-detect';

class PaymentsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {  
            tabIndex: 0,
            tabMenuItems: [
                { label: this.props.t('general.registration'), command: () => this.setState({tabIndex: 0}) },
                { label: this.props.t('quotes.menu'), command: () => this.setState({tabIndex: 1}) },
                { label: this.props.t('orders.menu'), command: () => this.setState({tabIndex: 2}) }
            ]
        };
    }

    setActiveIndex(index) {
        this.setState({tabIndex: index});
    }

    render() {
        return (
            <div>
                <PageTitleComponent title={this.props.t('finance.title')} />
                {
                    this.props.registrationRef !== null ?
                    <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                        <div className='col-1'></div>
                        <div className='col-10'>
                            <TabMenu model={this.state.tabMenuItems} activeIndex={this.state.tabIndex} onTabChange={(e) => this.setState({tabIndex: e.index})} />
                            { this.state.tabIndex === 0 ? <RegistrationPaymentListComponent /> : null }
                            { this.state.tabIndex === 1 ? <QuotePaymentListComponent /> : null }
                            { this.state.tabIndex === 2 ? <OrdersListComponent /> : null }
                        </div>
                        <div className='col-1'></div>
                    </div>
                    : null
                }
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        language: state.profile.language
    } 
};

export default connect(mapStateToProps, undefined)(authenticationChecker(withTranslation(PaymentsPage)));